
export class AthleteDetailWithStandard {

    id: number = 0;
    Standard: string = "";
    Course: string = "";
    Competition: string = "";
    Date: string = "";
    Time: string = "";
    A11: string = "";
    A12: string = "";
    A13: string = "";
    A14: string = "";
    A15: string = "";
    A16: string = "";
    A17: string = "";
    A18: string = "";
    Open: string = "";
    Junior: string = "";
    Senior: string = "";
    UsportSCM: string = "";
}
